module.exports = __webpack_public_path__ + "img/user.fd49f637.svg";